import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { ConfigurationSmartTef } from '@gipi-configuration/configuration/models/smart-tef.model';
import { ConfigurationConfigurationService } from '@gipi-configuration/configuration/services/configuration.service';
import { OptionActiveSituation, OptionActiveSituationEnum } from '@gipi-shared/enums/option-active-situation.enum';
import { APP_MESSAGES, GIPIAbstractComponent, GIPIBaseService, INJECTOR, ObjectUtil, StringUtil } from '@gipisistemas/ng-core';

@Component({
    templateUrl: './integration-smart-tef-dialog.component.html',
    styleUrls: ['./integration-smart-tef-dialog.component.scss'],
})
export class IntegrationSmartTefDialogComponent extends GIPIAbstractComponent implements OnInit {

    public smartTefConfig: ConfigurationSmartTef = new ConfigurationSmartTef();

    public optionActiveSituationEnum: typeof OptionActiveSituationEnum = OptionActiveSituationEnum;
    public optionActiveSituationValue: OptionActiveSituation = 'DISABLED';

    public typeIntegrationList: { label: string, type: 'AUTHENTICATED' | 'UNAUTHENTICATED' }[] = [
        { label: 'Com autenticação', type: 'AUTHENTICATED' },
        { label: 'Sem autenticação', type: 'UNAUTHENTICATED' },
    ];
    public typeIntegrationValue: 'AUTHENTICATED' | 'UNAUTHENTICATED' = 'UNAUTHENTICATED';

    constructor(
        protected baseService: GIPIBaseService,
        protected activatedRoute: ActivatedRoute,
        private _configurarionService: ConfigurationConfigurationService,
        public dialogRef: MatDialogRef<IntegrationSmartTefDialogComponent>,
    ) {
        super(baseService, activatedRoute);
        this.dialogRef.disableClose = true;
        this._findSmartTefConfiguration();
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    private _findSmartTefConfiguration(): void {
        try {
            this.loading = true;
            this.optionActiveSituationValue = 'ENABLED';

            this._configurarionService.findSmartTef().toPromise().then(configuration => {
                if (!ObjectUtil.isNull(configuration)) {
                    this.smartTefConfig = ObjectUtil.clone(configuration);
                    this.optionActiveSituationValue = (this.smartTefConfig.enabled ? 'ENABLED' : 'DISABLED');

                    this.typeIntegrationValue = (!StringUtil.isEmpty(configuration.jwtStoreToken) && !StringUtil.isEmpty(configuration.gwStoreToken))
                        ? 'UNAUTHENTICATED'
                        : 'AUTHENTICATED';
                }
                this.loading = false;
            }).catch(e => {
                this.loading = false;
                this.addErrorMessage(e);
            });
        } catch (e) {
            this.loading = false;
            this.handleError(e);
        }
    }

    private _isValid(): boolean {
        if (ObjectUtil.isNull(this.smartTefConfig)) {
            this.addWarningMessage('Objeto não pode ser vazio');
            return false;
        }

        if (StringUtil.isEmpty(this.smartTefConfig.baseUrl)) {
            this.addWarningMessage('Campo "URL Base" é obrigatório e não foi informado');
            return false;
        }

        if (this.typeIntegrationValue === 'AUTHENTICATED') {
            if (StringUtil.isEmpty(this.smartTefConfig.gwIntegrationToken)) {
                this.addWarningMessage(
                    'Campo "GW Token da integração" é obrigatório e não foi informado',
                );
                return false;
            }
            if (StringUtil.isEmpty(this.smartTefConfig.jwtIntegrationToken)) {
                this.addWarningMessage(
                    'Campo "JWT Token da integração" é obrigatório e não foi informado',
                );
                return false;
            }
            if (StringUtil.isEmpty(this.smartTefConfig.gwStoreToken)) {
                this.addWarningMessage(
                    'Campo "GW Token da loja" é obrigatório e não foi informado',
                );
                return false;
            }
        } else {
            if (StringUtil.isEmpty(this.smartTefConfig.gwStoreToken)) {
                this.addWarningMessage(
                    'Campo "GW Token da loja" é obrigatório e não foi informado',
                );
                return false;
            }
            if (StringUtil.isEmpty(this.smartTefConfig.jwtStoreToken)) {
                this.addWarningMessage(
                    'Campo "JWT Token da loja" é obrigatório e não foi informado',
                );
                return false;
            }
        }

        return true;
    }

    public confirm(): void {
        try {
            if (!this._isValid()) {
                return;
            }
            this.loading = true;

            if (this.typeIntegrationValue === 'AUTHENTICATED') {
                this.smartTefConfig.jwtStoreToken = '';
            } else {
                this.smartTefConfig.gwIntegrationToken = '';
                this.smartTefConfig.jwtIntegrationToken = '';
            }

            this.smartTefConfig.enabled = (this.optionActiveSituationValue === 'ENABLED');

            this._configurarionService.saveSmartTef(this.smartTefConfig).toPromise().then(response => {
                if (!ObjectUtil.isNull(response)) {
                    this.loading = false;
                    this.addSuccessMessage(INJECTOR.get(APP_MESSAGES).SUCCESS);

                    if (ObjectUtil.isNull(this._configurarionService.updated$)) {
                        this._configurarionService.updated$ = new BehaviorSubject(false);
                    }
                    this._configurarionService.updated$.next(true);

                    this.close();
                }
            }).catch(e => {
                this.loading = false;
                this.handleError(e);
            });
        } catch (e) {
            this.loading = false;
            this.handleError(e);
        }
    }

    public close(): void {
        this.dialogRef.close();
    }

}
